/* eslint-disable */
import { combineReducers, } from 'redux';

import headers from './headers';

export default combineReducers({
  headers,
});